import { createSlice } from '@reduxjs/toolkit'
import { ActeurActionState } from '../../types/actorActionTypes'
import {
  createActeurActionAsync,
  fetchActeursByActionId,
  fetchMyActions,
  updateActeurActionAsync,
} from './actorActionAction'

const initialState: ActeurActionState = {
  acteurAction: null,
  loading: false,
  error: null,
  actions: {
    Responsable: [],
    Approbateur: [],
  },
}

const acteurActionSlice = createSlice({
  name: 'acteurAction',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createActeurActionAsync.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(createActeurActionAsync.fulfilled, (state, action) => {
        state.loading = false
        state.acteurAction = action.payload
      })
      .addCase(createActeurActionAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || 'Something went wrong'
      })
      .addCase(fetchActeursByActionId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchActeursByActionId.fulfilled, (state, action) => {
        state.loading = false
        console.log('action.payload', action.payload)
        state.acteurAction = action.payload
      })
      .addCase(fetchActeursByActionId.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || 'Something went wrong'
      })
      .addCase(updateActeurActionAsync.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateActeurActionAsync.fulfilled, (state, action) => {
        state.loading = false
        state.acteurAction = action.payload
      })
      .addCase(updateActeurActionAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || 'Something went wrong'
      })
      .addCase(fetchMyActions.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchMyActions.fulfilled, (state, action) => {
        state.loading = false
        state.actions = action.payload
      })
      .addCase(fetchMyActions.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || 'Something went wrong'
      })
  },
})

export default acteurActionSlice.reducer
